import React from 'react';
import { motion } from 'framer-motion';
import { Star, MessageCircle } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    text: 'Por fin un libro de psicología que habla como la gente normal. Las técnicas para frenar los pensamientos catastróficos a la noche me cambiaron la semana.',
    author: 'Mariana G.',
    location: 'Córdoba'
  }, {
    text: 'No podía pagar los $8.000 o $10.000 que me cobraban por cada sesión de terapia semanal. Este libro me dio herramientas concretas para empezar a ponerle límites a mi jefe sin culpa.',
    author: 'Lautaro P.',
    location: 'Rosario'
  }, {
    text: 'La guía para domar al crítico interior vale cada centavo. Es un antes y un después en cómo me hablo a mí misma.',
    author: 'Carla M.',
    location: 'Buenos Aires'
  }];
  return <section className="py-12 md:py-16 bg-white" data-id="element-281">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-282">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-283">
          <div className="inline-flex items-center justify-center gap-2 text-teal font-bold tracking-wider uppercase mb-4" data-id="element-284">
            <MessageCircle className="w-6 h-6" data-id="element-285" />
            <span data-id="element-286">Prueba Social</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-display font-bold text-dark mb-6" data-id="element-287">
            💬 PERSONAS REALES QUE YA COMENZARON SU CAMBIO
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-288">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-cream p-8 rounded-3xl relative" data-id="element-289">
              <div className="flex gap-1 mb-6" data-id="element-290">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-gold fill-gold" data-id="element-291" />)}
              </div>
              <p className="text-dark-light text-lg italic mb-8 leading-relaxed" data-id="element-292">
                "{testimonial.text}"
              </p>
              <div className="flex items-center gap-3 mt-auto" data-id="element-293">
                <div className="w-10 h-10 bg-coral/20 rounded-full flex items-center justify-center text-coral font-bold" data-id="element-294">
                  {testimonial.author.charAt(0)}
                </div>
                <div data-id="element-295">
                  <p className="font-bold text-dark" data-id="element-296">{testimonial.author}</p>
                  <p className="text-sm text-dark-light" data-id="element-297">
                    — {testimonial.location}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}